import { render } from "./LivePage.vue?vue&type=template&id=2c696d51"
import script from "./LivePage.vue?vue&type=script&lang=js"
export * from "./LivePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__